import { Box } from '@mui/material';
import React from 'react';
import DiscoveryTab from './DiscoveryTab';
import { DiscoveryCountryCodeType } from 'src/interfaces/iproptypes';

const BottomDiscoveryDrawer = ({
  discoveryMarkets,
  setTopPerformingMarketOnFocus,
  marketsToCompareList,
  setMarketsToCompareList,
  setDashboardLayoutView,
  minROI,
  maxROI,
  isMarketDataAccessible,
  freeMarketDataKey,
  currency,
  mapWidth,
  setMapWidth,
  isDiscoveryMapViewOpen,
  setIsDiscoveryMapViewOpen,
  handleOnSampleClick,
  discoveryMarketType,
  setDiscoveryMarketType,
  allRawMarketData,
  discoverTabData,
  setDiscoveryTabData,
  selectedDiscoveryCountry,
  setSelectedDiscoveryCountry,
  isDiscoveryMarketLoading,
}: {
  discoveryMarkets: any[];
  setTopPerformingMarketOnFocus: any;
  marketsToCompareList: any[];
  setMarketsToCompareList: any;
  setDashboardLayoutView: any;
  minROI: number;
  maxROI: number;
  isMarketDataAccessible: boolean;
  freeMarketDataKey: string[];
  currency: string;
  mapWidth: number;
  setMapWidth: any;
  isDiscoveryMapViewOpen: boolean;
  setIsDiscoveryMapViewOpen: any;
  handleOnSampleClick: any;
  discoveryMarketType: any;
  setDiscoveryMarketType: any;
  allRawMarketData:any[];
  discoverTabData: any;
  setDiscoveryTabData;
  selectedDiscoveryCountry: DiscoveryCountryCodeType;
  setSelectedDiscoveryCountry: React.Dispatch<React.SetStateAction<DiscoveryCountryCodeType>>;
  isDiscoveryMarketLoading: boolean;
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        height: '40vh',
        // borderRadius: '10px 10px 0px 0px',
        backgroundColor: '#ffff',
      }}
    >
      <DiscoveryTab
        discoveryMarkets={discoveryMarkets}
        setTopPerformingMarketOnFocus={setTopPerformingMarketOnFocus}
        marketsToCompareList={marketsToCompareList}
        setMarketsToCompareList={setMarketsToCompareList}
        setDashboardLayoutView={setDashboardLayoutView}
        // minROI={minROI}
        // maxROI={maxROI}
        isMarketDataAccessible={isMarketDataAccessible}
        freeMarketDataKey={freeMarketDataKey}
        currency={currency}
        mapWidth={mapWidth}
        setMapWidth={setMapWidth}
        isDiscoveryMapViewOpen={isDiscoveryMapViewOpen}
        setIsDiscoveryMapViewOpen={setIsDiscoveryMapViewOpen}
        handleOnSampleClick={handleOnSampleClick}
        discoveryMarketType={discoveryMarketType}
        setDiscoveryMarketType={setDiscoveryMarketType}
        allRawMarketData={allRawMarketData}
        discoverTabData={discoverTabData}
        setDiscoveryTabData={setDiscoveryTabData}
        selectedDiscoveryCountry={selectedDiscoveryCountry}
        setSelectedDiscoveryCountry={setSelectedDiscoveryCountry}
        isDiscoveryMarketLoading={isDiscoveryMarketLoading}
      />
    </Box>
  );
};

export default BottomDiscoveryDrawer;
